<!-- HEADER escuro: a página é toda sobre ocorrências. -->
<div class="header bg-dark">
  <div class="container-fluid">
    <div class="header-body border-0">
      <div class="row align-items-end">
        <div class="col">
          <h6 class="header-pretitle text-secondary">{{ currentYear }}</h6>
          <h1 class="header-title text-white">Visão geral</h1>
          <div class="mt-2 small">
            @switch (system()) {
              @case ('loading') { <span class="dot dot--pulse"></span> <span class="text-white-50">Verificando sistema…</span> }
              @case ('online') { <span class="dot dot--online"></span> <span class="text-white-50">Sistema operacional</span> }
              @case ('offline') { <span class="dot dot--offline"></span> <span class="text-white-50">Sistema indisponível</span> }
            }
          </div>
        </div>
        <div class="col-auto">
          <ul class="nav nav-tabs header-tabs">
            <li class="nav-item">
              <a class="nav-link text-center active">
                <h6 class="header-pretitle text-secondary">No ano</h6>
                <h3 class="text-white mb-0">{{ occStats()?.total ?? 0 }}</h3>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link text-center">
                <h6 class="header-pretitle text-secondary">Por analisar</h6>
                <h3 class="text-white mb-0">{{ occRegistadas() }}</h3>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link text-center">
                <h6 class="header-pretitle text-secondary">Em tratamento</h6>
                <h3 class="text-white mb-0">{{ occInTreatment() }}</h3>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Sem ocorrências não se desenha nada: o gráfico vazio mostrava eixos de −1 a 1. -->
    @if (hasOccurrenceSeries()) {
      <div class="header-footer">
        <!-- Duas linhas sem nome não se leem. A legenda diz o que é cada uma e de que período. -->
        <div class="d-flex flex-wrap align-items-center gap-3 small text-white-50 mb-2">
          <span>Ocorrências acumuladas nos últimos 21 dias</span>
          <span class="d-inline-flex align-items-center gap-1">
            <span class="dash-key dash-key--created"></span> Registadas
          </span>
          <span class="d-inline-flex align-items-center gap-1">
            <span class="dash-key dash-key--closed"></span> Fechadas
          </span>
        </div>
        <div class="chart">
          <canvas #lineCanvas class="chart-canvas"></canvas>
        </div>
      </div>
    } @else {
      <div class="header-footer pb-4">
        <p class="text-white-50 small mb-0">
          Assim que houver ocorrências registadas, aparece aqui a evolução dos últimos 21 dias.
        </p>
      </div>
    }
  </div>
</div>

<!-- OCORRÊNCIAS — cards sobrepostos ao header -->
<!-- O `mb-4` das linhas com cartões `h-100` não é decoração: o cartão passa a ter a altura da
     coluna e a sua margem inferior fica de fora dela, pelo que a linha seguinte encostaria. -->
<div class="container-fluid mt-n6">
  <div class="row mb-4">
    <div class="col-12 col-xl-8">
      <div class="card h-100">
        <div class="card-header">
          <div class="d-flex align-items-center">
            <span class="avatar avatar-sm me-3"><span class="avatar-title fs-lg rounded bg-warning-soft text-warning"><i class="fe fe-layers"></i></span></span>
            <h4 class="card-header-title mb-0">Tipos mais frequentes</h4>
          </div>
          <a class="btn btn-sm btn-white" routerLink="../estatisticas">Ver estatísticas</a>
        </div>
        <div class="card-body">
          @if ((occStats()?.byType ?? []).length === 0) {
            <p class="text-muted mb-0">Sem ocorrências em {{ currentYear }}.</p>
          } @else {
            <app-echart [options]="occTypeBar()" [height]="240" />
          }
        </div>
      </div>
    </div>

    <div class="col-12 col-xl-4">
      <div class="card h-100">
        <div class="card-header">
          <div class="d-flex align-items-center">
            <span class="avatar avatar-sm me-3"><span class="avatar-title fs-lg rounded bg-info-soft text-info"><i class="fe fe-pie-chart"></i></span></span>
            <h4 class="card-header-title mb-0">Por origem</h4>
          </div>
        </div>
        <div class="card-body">
          @if ((occStats()?.byOrigin ?? []).length === 0) {
            <p class="text-muted mb-0">Sem ocorrências em {{ currentYear }}.</p>
          } @else {
            <app-echart [options]="occOriginDonut()" [height]="240" />
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Números do ano -->
  <div class="row">
    <div class="col-12 col-lg-6 col-xl-3">
      <div class="card">
        <div class="card-body">
          <div class="row align-items-center gx-0">
            <div class="col">
              <h6 class="text-uppercase text-muted mb-2">Ocorrências no ano</h6>
              <span class="h2 mb-0">{{ occStats()?.total ?? 0 }}</span>
            </div>
            <div class="col-auto"><span class="h2 fe fe-alert-triangle text-muted mb-0"></span></div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-6 col-xl-3">
      <div class="card">
        <div class="card-body">
          <div class="row align-items-center gx-0">
            <div class="col">
              <h6 class="text-uppercase text-muted mb-2">Por analisar</h6>
              <span class="h2 mb-0">{{ occRegistadas() }}</span>
            </div>
            <div class="col-auto"><span class="h2 fe fe-inbox text-muted mb-0"></span></div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-6 col-xl-3">
      <div class="card">
        <div class="card-body">
          <div class="row align-items-center gx-0">
            <div class="col">
              <h6 class="text-uppercase text-muted mb-2">Prazos a vencer</h6>
              <span class="h2 mb-0">{{ occDeadlines().length }}</span>
            </div>
            <div class="col-auto"><span class="h2 fe fe-clock text-muted mb-0"></span></div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-6 col-xl-3">
      <div class="card">
        <div class="card-body">
          <div class="row align-items-center gx-0">
            <div class="col">
              <h6 class="text-uppercase text-muted mb-2">Fechadas no prazo</h6>
              @if (occOnTimePct() !== null) {
                <div class="d-flex align-items-center">
                  <span class="h2 me-3 mb-0">{{ occOnTimePct() }}%</span>
                  <div class="progress progress-sm flex-fill">
                    <div class="progress-bar bg-success" [style.width.%]="occOnTimePct()"></div>
                  </div>
                </div>
              } @else {
                <span class="h2 mb-0">—</span>
              }
            </div>
            <div class="col-auto"><span class="h2 fe fe-check-circle text-muted mb-0"></span></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Recentes + prazos -->
  <div class="row mb-4">
    <div class="col-12 col-xl-8">
      <div class="card h-100">
        <div class="card-header">
          <div class="d-flex align-items-center">
            <span class="avatar avatar-sm me-3"><span class="avatar-title fs-lg rounded bg-warning-soft text-warning"><i class="fe fe-alert-triangle"></i></span></span>
            <h4 class="card-header-title mb-0">Ocorrências recentes</h4>
          </div>
          <a class="btn btn-sm btn-white" routerLink="../ocorrencias">Ver todas</a>
        </div>
        <div class="card-body p-0">
          <div class="list-group list-group-flush">
            @for (o of occRecent(); track o.id) {
              <a class="list-group-item d-flex align-items-center gap-3" [routerLink]="['../ocorrencias', o.id]">
                <span class="avatar avatar-sm">
                  <span class="avatar-title fs-lg rounded bg-warning-soft text-warning"><i class="fe" [class]="typeIcons[o.type]"></i></span>
                </span>
                <div class="flex-grow-1 min-w-0">
                  <span class="fw-bold d-block text-truncate">{{ o.title }}</span>
                  <span class="small text-muted">{{ o.code }} · {{ o.occurrenceDate | date: 'dd/MM/yyyy' }}</span>
                </div>
                <span class="badge" [class]="occBadgeClass(o)">{{ occStateLabel(o) }}</span>
              </a>
            } @empty {
              <p class="text-muted text-center py-5 mb-0">Ainda não há ocorrências em {{ currentYear }}.</p>
            }
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-xl-4">
      <div class="card h-100">
        <div class="card-header">
          <div class="d-flex align-items-center">
            <span class="avatar avatar-sm me-3"><span class="avatar-title fs-lg rounded bg-danger-soft text-danger"><i class="fe fe-clock"></i></span></span>
            <h4 class="card-header-title mb-0">Prazos a vencer</h4>
          </div>
        </div>
        <div class="card-body p-0">
          <div class="list-group list-group-flush">
            @for (o of occDeadlines(); track o.id) {
              <a class="list-group-item d-flex align-items-center gap-3" [routerLink]="['../ocorrencias', o.id]">
                <div class="flex-grow-1 min-w-0">
                  <span class="fw-bold d-block text-truncate">{{ o.title }}</span>
                  <span class="small text-muted">{{ o.code }}</span>
                </div>
                <span class="small fw-bold text-warning text-nowrap">
                  {{ o.actionImplementationDeadline | date: 'dd/MM' }}
                </span>
              </a>
            } @empty {
              <p class="text-muted text-center py-5 mb-0">Nenhum prazo a vencer.</p>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
